import { Routes, Route } from 'react-router-dom';
import { Register } from '@/pages/Register';
import { RegistrationSuccess } from '@/pages/RegistrationSuccess';
import { SelfSchedule } from '@/pages/SelfSchedule';
import { ScheduleConfirmation } from '@/pages/ScheduleConfirmation';
import { NotFound } from '@/pages/NotFound';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Register />} />
      <Route path="/success" element={<RegistrationSuccess />} />
      <Route path="/schedule" element={<SelfSchedule />} />
      <Route path="/schedule/confirmed" element={<ScheduleConfirmation />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default App;
